import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useIntl, FormattedMessage, FormattedDate } from 'react-intl';
import { get,  put } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import { useNotifier } from '../../contexts/NotificationContext';

import Title from '../../components/common/Title/Title';
import Card from '../../components/common/Card/Card';
import AnswerRenderer from '../../components/AnswerRenderer/AnswerRenderer';
import styles from './SingleAnswerPage.module.css';
import {hapticFeedback, showBackButton} from "../../services/telegramService";
import {FiCopy} from "react-icons/fi";
import NotFoundPage from "../NotFoundPage/NotFoundPage";

const SingleAnswerPage = () => {
    const { formId, submissionId } = useParams();
    const [submission, setSubmission] = useState(null);
    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();
    const navigate = useNavigate();
    const intl = useIntl();
    const [formNotFound, setFormNotFound] = useState(false);

    useEffect(() => {
        showBackButton();
    }, []);

    useEffect(() => {
        showPageLoader();
        get(`forms/${formId}/submissions/${submissionId}`)
            .then(response => {
                if (response.data) {
                    setSubmission(response.data);
                }
            })
            .catch(error => {
                setFormNotFound(true);
                // addNotification(error.message || 'Failed to load submission.', 'error');
                // navigate(-1);
            })
            .finally(() => hidePageLoader());
    }, [submissionId, showPageLoader, hidePageLoader, addNotification, navigate]);

    useEffect(() => {
        // Отправляем запрос, как только у нас есть ID анкеты
        if (submissionId) {
            // Нам не нужно ждать ответа или обрабатывать его,
            // просто "выстреливаем" запросом в фоне.
            put(`form-submissions/${submissionId}/mark-as-read`)
                .catch(err => {
                    console.error("Failed to mark as read:", err);
                });
        }
    }, [submissionId]);

    const handleCopyId = (id) => {
        if (!id) return;
        navigator.clipboard.writeText(id).then(() => {
            // Показываем уведомление об успехе
            addNotification(intl.formatMessage({ id: "singleAnswerPage.submitterIdCopied" }), 'success');
            hapticFeedback('notification', 'success');
        }).catch(err => {
            console.error('Failed to copy ID: ', err);
            addNotification('Failed to copy', 'error');
        });
    };

    if (formNotFound) {
        return <NotFoundPage />;
    }

    if (!submission) {
        return null;
    }

    return (
        <div>
            <Title>
                {/*<FormattedMessage id="singleAnswerPage.title" values={{ id: submission.id.toString().substring(0, 8) }}/>*/}
                <FormattedMessage id="singleAnswerPage.title" values={{ id: submission.submission_number }}/>
            </Title>

            <Card className={styles.infoCard}>
                <div className={styles.infoRow}>
                    <span className={styles.infoLabel}><FormattedMessage id="singleAnswerPage.submittedOn" /></span>
                    <span className={styles.infoValue}>
                        <FormattedDate value={submission.submitted_at} year="numeric" month="long" day="numeric" hour="numeric" minute="numeric" />
                    </span>
                </div>
                <div className={styles.infoRow}>
                    <span className={styles.infoLabel}><FormattedMessage id="singleAnswerPage.submitterName"/></span>
                    {/*<span className={styles.infoValue}>{submission.submitter_id || <FormattedMessage id="submission.item.anonymous" />}</span>*/}
                    <div className={styles.submitterValueContainer}>
                        <span className={styles.infoValue}>
                            {submission.submitter_id || <FormattedMessage id="submission.item.anonymous"/>}
                        </span>

                        {/* Показываем кнопку, только если есть ID */}
                        {submission.submitter_id && (
                            <button
                                className={styles.copyButton}
                                onClick={() => handleCopyId(submission.submitter_id)}
                                title={intl.formatMessage({id: "singleAnswerPage.copySubmitterIdTooltip"})}
                            >
                                <FiCopy/>
                            </button>
                        )}
                    </div>
                </div>
            </Card>

            {/* --- НОВЫЙ БЛОК ОТОБРАЖЕНИЯ ОТВЕТОВ --- */}
            <div className={styles.answersList}>
                {submission.answers.map((answer, index) => (
                    <div key={answer.id} className={styles.qaBlock}>
                        <div className={styles.questionHeader}>
                            <span className={styles.questionNumber}>{index + 1}</span>
                            <p className={styles.questionText}>{answer.question.text}</p>
                        </div>
                        <div className={styles.answerWrapper}>
                            <AnswerRenderer answer={answer}/>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SingleAnswerPage;
